import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'

const getInitialState = () => {
  return Map({
    isSyncing: false,
    isAutomatic: false,
    dataIsUploading: false,
    safIsUploading: false,
    safStatusRequesting: false,
    safStatusProgress: null,
    errorCallback: null,
    somethingToSync: false,
    stateCount: 0,
    safCount: 0,
    dataCount: 0,
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNSYNC_MANAGER_SHOULD_START_SYNC:
      return state.set('isSyncing', true).set('isAutomatic', action.isAutomatic).set('errorCallback', action.errorCallback)

    case ActionTypes.VNSYNC_MANAGER_SHOULD_STOP_SYNC:
      return state.set('isSyncing', false).set('isAutomatic', false).set('errorCallback', null)

    case ActionTypes.VNSYNC_MANAGER_SET_DATA_IS_UPLOADING:
      return state.set('dataIsUploading', action.dataIsUploading)

    case ActionTypes.VNSYNC_MANAGER_SET_SAF_IS_UPLOADING:
      return state.set('safIsUploading', action.safIsUploading)

    case ActionTypes.VNSYNC_MANAGER_SET_SAF_STATUS_REQUESTING:
      return state.set('safStatusRequesting', action.safStatusRequesting)

    case ActionTypes.VNSYNC_MANAGER_SET_SAF_STATUS_PROGRESS:
      return state.set('safStatusProgress', action.remainingOrders)

    case ActionTypes.VNSYNC_MANAGER_SET_SOMETHING_TO_SYNC:
      return state
        .set('somethingToSync', action.stateCount > 0 || action.safCount > 0 || action.dataCount > 0)
        .set('stateCount', action.stateCount)
        .set('safCount', action.safCount)
        .set('dataCount', action.dataCount)

    default:
      return state
  }
}

export default reducer
